import React, { FC, useState, useEffect } from 'react'
import { Box, TextField } from '@material-ui/core'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Tag, TagState } from 'Models/Tag/@types';
import { useSelector } from 'react-redux';
import { ReduxStore } from 'stores';
import TagsList from './TagsList';
import utilities from 'Resources/Utils';

export interface TagsListSelectionFormProps {
    initialTags?: Tag[];
    onChange?: (tags: Tag[]) => any;
}

const TagsListSelectionForm: FC<TagsListSelectionFormProps> = (props) => {
    const classes = useStyles();
    const { initialTags = [], onChange } = props;
    const [selectedTags, setSelectedTags] = useState<Tag[]>([]);
    const { list: tagsList = [] } = useSelector<ReduxStore, Pick<TagState, 'list'>>(({ Tag: { list } }) => ({ list }));

    useEffect(() => {
        setSelectedTags(initialTags);
        console.log("I ran more than one");
        // eslint-disable-next-line
    }, [initialTags.length]);

    const handleChange = (tags: Tag[]) => {
        onChange?.(tags);
        setSelectedTags(tags);
    }

    return (
        <Box>
            <Box className={classes.inputContainer} >
                <Autocomplete<Tag, boolean, boolean>
                    multiple
                    options={tagsList}
                    getOptionLabel={option => option.name}
                    filterSelectedOptions
                    onChange={(e, v) => { Array.isArray(v) && handleChange(v) }}
                    value={selectedTags}
                    disableClearable
                    renderTags={() => null}
                    renderInput={params => (
                        <TextField
                            {...params}
                            label="Select Tags"
                            placeholder="Tags"
                            fullWidth
                        />
                    )}
                />
            </Box>
            <TagsList color={'secondary'} variant={'outlined'} list={selectedTags} onDelete={(tag) => setSelectedTags(utilities.toggleItemFromList(selectedTags, tag))} />
        </Box>
    )
}

const useStyles = makeStyles<Theme>((theme) => {
    return (createStyles({
        inputContainer: {
            marginBottom: 16
        }
    }))
})

export default TagsListSelectionForm